if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeHelloCards);
} else {
  initializeHelloCards()
}

function initializeHelloCards () {
  const helloCards = document.getElementsByClassName('hello-card');
  Array.from(helloCards).forEach((helloCard) => {
    initializeCard(helloCard)
  })
}

function initializeCard (cardElement) {
  const contentElement = cardElement.querySelector('.hello-card__content')
  if (!contentElement) return

  const textElements = cardElement.querySelectorAll('.hello-card__heading, .hello-card__description, .hello-card__caption')
  textElements.forEach(textElement => {
    if (textElement.firstElementChild.classList.contains('metafield-rich_text_field')) {
      textElement.dataset.text = textElement.firstChild.innerHTML
      textElement.innerHTML = textElement.firstChild.innerHTML
    }
    initializeTextContent(textElement)
  })

  const divChildren = Array.from(contentElement.children).filter(el => el.tagName === 'DIV')
  if (divChildren.length === 0) {
    return
  } else if (divChildren.length === 1) {
    divChildren[0].classList.add('hello-card__first', 'hello-card__last')
    return
  }

  let firstOrder = Number(getComputedStyle(divChildren[0]).order)
  let lastOrder = Number(getComputedStyle(divChildren[0]).order)
  let firstElement = divChildren[0]
  let lastElement = divChildren[0]

  if (!firstOrder) return
  divChildren.forEach(el => {
    const currentOrder = Number(getComputedStyle(el).order)
    if (currentOrder < firstOrder) {
      firstOrder = currentOrder
      firstElement = el
    }
    if (currentOrder > lastOrder) {
      lastOrder = currentOrder
      lastElement = el
    }
  })
  firstElement.classList.add('hello-card__first')
  lastElement.classList.add('hello-card__last')
}

function initializeTextContent (element) {
  if (element && element.dataset.text?.trim()) {
    let parsedText = parseHtml(element.dataset.text)
    let splittedText = parsedText.split('<p>&lt;hr&gt;</p>')
    if (splittedText.length > 1) {
      parsedText = splittedText
        .map(item => `<div>${item?.trim()}</div>`)
        .join('')
    }
    element.innerHTML = parsedText
  }
}